import { createSlice } from '@reduxjs/toolkit';

import { editVenueDates } from '@/domain/project-venue-dates/actions/edit-venue-dates.action.ts';
import { VenueDate } from '@/domain/project-venue-dates/entities/project-venue-dates.entity';

import { bulkAddVenueDates } from './actions/bulk-add-venue-date.action';
import { getVenueDates } from './actions/get-venue-dates.action';
import { importVenueDatesFromHeeds } from './actions/import-venue-dates-from-heeds';
import { importVenueDatesFromOrfeo } from './actions/import-venue-dates-from-orfeo';

export type ProjectVenueDatesState = {
  items: VenueDate[];
  isImportingDates: boolean;
  isCreatingDates: boolean;
};

const initialState: ProjectVenueDatesState = {
  items: [],
  isImportingDates: false,
  isCreatingDates: false,
};

export const projectVenueDatesSlice = createSlice({
  name: 'projectVenueDates',
  initialState,
  reducers: {
    clearItems(state) {
      state.items = [];
    },
  },
  extraReducers(builder) {
    builder.addCase(getVenueDates.fulfilled, (state, action) => {
      state.items = action.payload;
    });
    builder.addCase(editVenueDates.fulfilled, (state, action) => {
      const newItems = [];
      for (const item of state.items) {
        if (item.id === action.payload.id) {
          newItems.push(action.payload);
        } else {
          newItems.push(item);
        }
      }
      state.items = newItems;
    });
    // isCreatingDates
    builder.addCase(bulkAddVenueDates.pending, (state) => {
      state.isCreatingDates = true;
    });
    builder.addCase(bulkAddVenueDates.fulfilled, (state) => {
      state.isCreatingDates = false;
    });
    builder.addCase(bulkAddVenueDates.rejected, (state) => {
      state.isCreatingDates = false;
    });
    // isImportingDates
    builder.addCase(importVenueDatesFromHeeds.pending, (state) => {
      state.isImportingDates = true;
    });
    builder.addCase(importVenueDatesFromHeeds.fulfilled, (state) => {
      state.isImportingDates = false;
    });
    builder.addCase(importVenueDatesFromHeeds.rejected, (state) => {
      state.isImportingDates = false;
    });
    builder.addCase(importVenueDatesFromOrfeo.pending, (state) => {
      state.isImportingDates = true;
    });
    builder.addCase(importVenueDatesFromOrfeo.fulfilled, (state) => {
      state.isImportingDates = false;
    });
    builder.addCase(importVenueDatesFromOrfeo.rejected, (state) => {
      state.isImportingDates = false;
    });
  },
});
